import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  AfterContentInit,
  OnChanges,
  SimpleChanges,
  ContentChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { Observable, of, Subscription } from "rxjs";

@Component({
  selector: "web-info-icon-hoverable",
  templateUrl: "./info-icon-hoverable.component.html",
  styleUrls: ["./info-icon-hoverable.component.scss"],
})
export class InfoIconHoverableComponent implements AfterViewInit, AfterContentInit, OnDestroy, OnChanges {

  @Input() description: string = "";
  @Input() descriptionObservable: Observable<string> = of("");
  @Input() iconOverrides: string = "";
  @Input() position: "below" | "above" | "left" | "right" | "before" | "after" = "below";
  @Input() showIcon: boolean = true;
  @Input() overrides: string = "";
  @Input() tooltipClass: string = "";

  @Output() onMouseOver: EventEmitter<any> = new EventEmitter();

  @ViewChild("iconRef") iconRef!: any;
  @ContentChild('ng-content') contentChild!: ElementRef;

  public tooltipText: string = "";
  public hasContent: boolean = false;
  private _internalDescription: string = "";
  private subscription: Subscription = new Subscription();
  private isHovered: boolean = false;

  constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['description'] && this.description?.trim()) {
      this.tooltipText = this.description;
      this._internalDescription = this.description;
    }
  }

  ngAfterContentInit() {
    this.checkForProjectedContent();
    
    setTimeout(() => {
      this.checkForProjectedContent();
    }, 0);
  }

  ngAfterViewInit() {
    if (this.description?.trim()) {
      this.tooltipText = this.description;
      this._internalDescription = this.description;
    } else if (this.descriptionObservable) {
      const sub = this.descriptionObservable.subscribe((desc) => {
        this.tooltipText = desc || "";
        this._internalDescription = desc || "";
        this.cdr.detectChanges();
      });
      this.subscription.add(sub);
    } else {
      this.tooltipText = "";
    }
  }

  private checkForProjectedContent() {
    const nativeElement = this.elementRef.nativeElement;
    const children = Array.from(nativeElement.children) as HTMLElement[];
    const hasProjectedContent = children.length > 0 && 
      children.some(child => {
        const tagName = child.tagName.toLowerCase();
        return !tagName.includes('mat-icon') && !tagName.includes('span');
      });
    this.hasContent = hasProjectedContent;
  }

  onMouseEnter() {
    this.isHovered = true;
    this.onMouseOver.emit();
  }

  onMouseLeave() {
    this.isHovered = false;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
